<template>
    <v-card height="127">
        <v-card-subtitle class="">{{ header }}</v-card-subtitle>
        <v-divider />
        <v-card-text>
            <div v-if="loading" style="height: 100%" class="d-flex justify-center align-center">
                <v-icon size="30px" class="fa-spin" >
                    fa-spinner
                </v-icon>                    
            </div>
            <div v-else>
                <div class="display-1 text--primary">{{ formatter(value) }}</div>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    props: ['header', 'value', 'formatter', 'loading']
}
</script>